<template>

  <div class="secure-form">
    <div
      v-if="done"
      class="text-success"
    >
      <div>&nbsp;</div>
      <i class='fa fa-check fa-fw fa-4x'></i> Deine Nachricht wurde verschlüsselt übermittelt.
      <div>&nbsp;</div>
    </div>
    <div v-else>
      <form @submit.prevent="submit">

        <form-group
          :validator="$v.form.text"
          label="Was ist passiert?"
        >
          <textarea
            type="text"
            class="form-control"
            v-model="form.text"
            @input="$v.form.text.$touch()"
            name="text"
            rows="14"
          ></textarea>
        </form-group>

        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="form.allow_contact"
            id="allow_contact"
          >&nbsp;
          <label
            class="form-check-label"
            for="allow_contact"
          >Dürfen wir mit dir Kontakt aufnehmen ?</label>
        </div>
        <div>&nbsp;</div>

        <div v-if="form.allow_contact">

          <form-group
            :validator="$v.form.name"
            label="Name"
          >
            <input
              type="text"
              class="form-control"
              v-model="form.name"
              @input="$v.form.name.$touch()"
              name="name"
            />
          </form-group>

          <form-group
            :validator="$v.form.email"
            label="e-Mail"
          >
            <input
              type="text"
              class="form-control"
              v-model="form.email"
              @input="$v.form.email.$touch()"
              name="email"
            />
          </form-group>

          <form-group
            :validator="$v.form.fon"
            label="Telefon"
          >
            <input
              type="text"
              class="form-control"
              v-model="form.fon"
              @input="$v.form.fon.$touch()"
              name="fon"
            />
          </form-group>
        </div>
        <div>&nbsp;</div>
        <div class="centered">

          <button
            class="btn btn-nf2"
            type="submit"
            :disabled="waiting>0"
          >
            <i
              v-if="waiting>0"
              class='fa fa-spin fa-spinner fa-fw'
            ></i><i
              v-else
              class='fa fa-arrow-right fa-fw'
            ></i> Absenden</button>

        </div>

      </form>

    </div>
  </div>
</template>

<script>
import { handleErrorsFromResponse, displayNotifications } from "../utils.js";
import axios from "axios";
import { withParams } from "vuelidate/lib";

import {
  required,
  integer,
  helpers,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";

const slug = withParams({ type: "slug" }, function(value) {
  return !!(value && value.match(/^[a-z0-9]+$/));
});

export default {
  name: "VerteilerEdit",

  data: function() {
    return {
      waiting: 0,
      done: false,
      form: {
        text: "",
        name: "",
        fon: "",
        email: "",
        allow_contact: false
      }
    };
  },

  methods: {
    submit: function() {
      if (this.$v.form.$invalid) {
        this.$v.form.$touch();
        // this.$toast.open({
        //   message: "Bitte fülle alle rot markierten Felder aus."
        // });
      } else {
        console.log("#log", "submit");
        this.waiting = 1;
        axios
          .post(
            "https://engine1.naturfreunde.at/kinder_jugendschutz",
            this.form
          )
          .then(response => {
            console.log("#ok", response);
            this.waiting = 0;
            this.done = true;
          })
          .catch(error => {
            console.log("#error", error);
            this.waiting = 0;
          });
      }
    }
  },
  validations: {
    form: {
      text: { required },
      email: { email },
      fon: {},
      name: {}
    }
  }
};
</script>

<style lang="scss">
@import "../styles/settings.scss";

.verteiler-edit {
}
</style>
